
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class InputPositiveNumbers extends Vue {
  @Prop({ type: Number, required: false, default: 0 }) public minValue: number;
  @Prop({ type: String, required: false, default: '0' }) public id: string;
  @Prop({ type: Number, required: false, default: 4 }) public digitsNumberBefore: number;
  @Prop({ type: Number, required: false, default: 2 }) public digitsNumberAfter: number;
  @Prop({ type: Boolean, required: false, default: false }) public validation: boolean;
  @Prop({ type: Number, required: false, default: '' }) public value: number;
  @Prop({ type: Boolean, required: false, default: false }) public disabled: boolean;

  private inputValue = '';

  @Watch('value', { immediate: true })
  private watchPropValue() {
    this.inputValue = String(this.value);
  }

  @Watch('inputValue')
  private watchValue() {
    const newValue = this.inputValue.replace(/[^\d.]|\.(?=.*\.)/g, '');
    let newString = '';

    if (newValue.length === 1 && newValue[0] === '.') {
      // First symbol is '.'
      newString = '';
    } else if (newValue[newValue.length - 1] === '.') {
      // Last symbol is '.'
      newString = newValue.split('.')[0].substring(0, this.digitsNumberBefore) + '.';
    } else if (newValue.indexOf('.') >= 0 && newValue[newValue.length - 1] !== '.') {
      // Decimal
      const strBefore = newValue.split('.')[0].substring(0, this.digitsNumberBefore);
      const strAfter = newValue.split('.')[1].substring(0, this.digitsNumberAfter);
      newString = strBefore + '.' + strAfter;
    } else {
      // Just a number
      newString = newValue.substring(0, this.digitsNumberBefore);
    }

    this.inputValue = newString;

    this.$emit('changed', newString, this.id);
  }
}
